import React from 'react';
import clsx from 'clsx';
export const HelperText = props => {
    const { invalid = false, children, className } = props;
    return (React.createElement("p", { className: clsx('text-sm first-letter:capitalize', !invalid && 'text-content-subdued', invalid && 'text-action-destructive', className) }, children));
};
//# sourceMappingURL=HelperText.js.map